import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import MuiButton from "@mui/material/Button";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import useDialogBackButton from "@/react/hooks/useDialogBackButton";
import { Divider } from "@mui/material";
import CookieConsentDescription from "./CookieConsentDescription";
const NetlifeConsentSettingsDialog = ({ provider, onClose, }) => {
    const [t] = useTranslation();
    const [allowTracking, setAllowTracking] = useState(provider.getAllowTracking());
    // Hardware/browser back closes the dialog instead of navigating away.
    useDialogBackButton(true, onClose);
    const onSave = () => {
        provider.setAllowTracking(allowTracking);
        onClose();
    };
    return (React.createElement(Dialog, { open: true, onClose: onClose },
        React.createElement(DialogTitle, null, t("Cookie settings")),
        React.createElement(Divider, null),
        React.createElement(DialogContent, null,
            React.createElement("p", null,
                React.createElement(CookieConsentDescription, { onNavigate: onClose })),
            React.createElement(RadioGroup, { value: allowTracking ? "all" : "necessary", onChange: (event) => setAllowTracking(event.target.value === "all") },
                React.createElement(FormControlLabel, { value: "necessary", control: React.createElement(Radio, null), label: t("Use only necessary cookies") }),
                React.createElement(FormControlLabel, { value: "all", control: React.createElement(Radio, null), label: t("Allow all cookies") }))),
        React.createElement(DialogActions, null,
            React.createElement(MuiButton, { onClick: onSave, variant: "contained", color: "primary", autoFocus: true }, t("Save")))));
};
export default NetlifeConsentSettingsDialog;
